import React from "react";
import SidebarAdmin from "../../components/SidebarAdmin";
import TopBarDokterParuAdmin from "../../components/TopBarDokterParuAdmin";
import SemuaDokterParu from "../../components/SemuaDokterParu";
import "../../CSS/SemuaDataPasienAdmin.css";

function HalamanDokterParuAdmin() {
  return (
    <div className="profile-page-layout">
      {/* Sidebar kiri */}
      <SidebarAdmin />

      {/* Area kanan */}
      <div className="content">
        <TopBarDokterParuAdmin />

        {/* Konten utama */}
        <div className="data-tenaga-page">
          <SemuaDokterParu/>
        </div>
      </div>
    </div>
  );
}

export default HalamanDokterParuAdmin;
